// Password-strength policy — kept in sync with the backend `core/password.py`.
export const PASSWORD_RULES = [
  { id: "length", label: "At least 8 characters", test: (p) => (p || "").length >= 8 },
  { id: "upper", label: "One uppercase letter", test: (p) => /[A-Z]/.test(p || "") },
  { id: "lower", label: "One lowercase letter", test: (p) => /[a-z]/.test(p || "") },
  { id: "symbol", label: "One symbol", test: (p) => /[^A-Za-z0-9]/.test(p || "") },
  {
    id: "repeat",
    label: "No more than 3 of the same character in a row",
    test: (p) => !/(.)\1\1\1/.test(p || ""),
  },
];

// Returns true when every rule passes.
export function passwordMeetsPolicy(p) {
  return PASSWORD_RULES.every((r) => r.test(p));
}

// Strength score for the Weak → Strong meter. level is 0 (empty) to 4 (Strong).
export function passwordStrength(p) {
  const pw = p || "";
  if (!pw) return { level: 0, label: "", percent: 0 };
  const passed = PASSWORD_RULES.filter((r) => r.test(pw)).length;
  let level;
  if (passed < PASSWORD_RULES.length) {
    level = passed <= 2 ? 1 : 2; // still missing rules: Weak / Fair
  } else {
    level = pw.length >= 12 ? 4 : 3; // all rules met: Strong (12+) / Good
  }
  const labels = { 1: "Weak", 2: "Fair", 3: "Good", 4: "Strong" };
  return { level, label: labels[level], percent: (level / 4) * 100 };
}
